import { useCallback } from 'react';
import { getLang } from '../lib/i18n';
import en from '../i18n/en.json';
import el from '../i18n/el.json';

const dictionaries = { en, el };

export function useTranslation() {
    const currentLang = getLang();
    const dict = dictionaries[currentLang] || dictionaries['en'];

    const t = useCallback((key) => {
        const keys = key.split('.');
        let result = dict;
        for (const k of keys) {
            if (result[k] === undefined) {
                // Fallback to English if translation is missing
                let fallback = dictionaries['en'];
                for (const fbKey of keys) {
                    if (fallback[fbKey] === undefined) return key;
                    fallback = fallback[fbKey];
                }
                return fallback;
            }
            result = result[k];
        }
        return result;
    }, [dict]);

    return { t, currentLang };
}
